import React from 'react'
import { Text, TextSize, Weight } from 'components'
import styled from 'styled-components'

const Table = styled.table<{ height: string }>`
  height: ${({ height }) => height};
  border-collapse: collapse;
  width: fill-available;
  max-width: 365px;
`

const TableHead = styled.thead``
const TableBody = styled.tbody``

const Tr = styled.tr<{ height: string }>`
  height: ${({ height }) => height};
  vertical-align: top;
  &:last-of-type {
    td {
      border-bottom: none;
    }
  }
`
const Th = styled.th<{ position?: string }>`
  text-align: ${({ position }) => position ?? 'left'};
`
const Td = styled.td<{
  componentWidth: string
  blurLastColumn: boolean
  position?: string
}>`
  width: ${(props) => props.componentWidth};
  text-align: ${({ position }) => position ?? 'left'};
  &:last-of-type {
    opacity: ${({ blurLastColumn }) => (blurLastColumn ? 0.6 : 1)};
  }
`

const TitleText = styled(Text)`
  color: ${({ theme }) => theme.secondaryText};
  font-size: ${TextSize.small};
`

const StyledValueText = styled(Text)`
  font-size: ${TextSize.p};
  display: flex;
  align-items: center;
`
interface Headers {
  name: string
  textStyle?: string
  tableText?: {
    weight?: Weight
    width?: string
  }
  hideName?: boolean
}

interface IndexPerformanceProps {
  headers: Headers[]
  bodyArray: (string | number | JSX.Element)[][]
  height?: number
  blurLastColumn?: boolean
  position?: string
}

export const BaseTable = ({
  headers,
  bodyArray,
  height = 52,
  blurLastColumn = false,
}: IndexPerformanceProps): JSX.Element => {
  const heightInPixels = `${height}px`
  return (
    <Table height={`${(bodyArray.length + 1) * height}px`}>
      <TableHead>
        <Tr height={heightInPixels}>
          {headers.map((item, index) => (
            <Th key={`${item}-${index}`}>
              <TitleText weight={Weight.Medium}>{!item.hideName && item.name}</TitleText>
            </Th>
          ))}
        </Tr>
      </TableHead>
      <TableBody>
        {bodyArray.map((itemsArr: (string | JSX.Element | number)[], arrIndex: number) => {
          return (
            <Tr height={heightInPixels} key={arrIndex}>
              {itemsArr.map((item, index) => (
                <Td
                  blurLastColumn={blurLastColumn}
                  componentWidth={headers[index].tableText?.width || 'auto'}
                  key={`${item}-${index}`}
                >
                  <StyledValueText weight={headers[index].tableText?.weight || Weight.Medium}>
                    {item}
                  </StyledValueText>
                </Td>
              ))}
            </Tr>
          )
        })}
      </TableBody>
    </Table>
  )
}
